"use strict";
/**
 * Time-Off Request Request Types
 *
 * API request contracts for time-off request endpoints.
 *
 * @example POST /api/time-off-requests
 * @example PATCH /api/time-off-requests/:id
 */
Object.defineProperty(exports, "__esModule", { value: true });
